<template>
	<div>
		<v-card class="ma-5" v-for="anuncio in grupoUsar" :key="anuncio._id">
			<v-img
				v-if="anuncio.hasOwnProperty('linkIMG')"
				:src="anuncio.linkIMG"
				aspect-ratio="1"
				min-height="50"
			>
				<template v-slot:placeholder>
					<v-row class="fill-height ma-0" align="center" justify="center">
						<v-progress-circular indeterminate color="black"></v-progress-circular>
					</v-row>
				</template>
			</v-img>

			<v-card-title>{{ anuncio.titulo }}</v-card-title>
			<v-card-text>
				{{ anuncio.descripcion }}
			</v-card-text>
			<v-card-actions id="acciones">
				<v-btn icon v-if="anuncio.hasOwnProperty('link')" :href="anuncio.link">
					<v-icon color="primary">mdi-link-variant</v-icon></v-btn
				>
				<v-btn icon @click="share(anuncio)">
					<v-icon color="primary">mdi-share-variant</v-icon>
				</v-btn>
			</v-card-actions>
		</v-card>

		<!-- MODAL SHARE-->
		<share-modal
			:dialog="dialog_share"
			:data="toShare"
			v-on:closeShare="closeModal"
		></share-modal>

		<!-- NADA QUE MOSTRAR -->
		<nothing v-show="grupoUsar.length == 0 && !loading"></nothing>

		<!-- LOADING -->
		<v-overlay :value="loading" z-index="4">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</div>
</template>

<script>
import Nothing from "../components/Nothing";
import ShareModal from "../components/ShareModal";

export default {
	props: ["grupoUsar", "loading"],
	data: () => ({
		dialog_share: false,
		toShare: {}
	}),
	components: {
		Nothing,
		ShareModal
	},
	methods: {
		share(data) {
			let clearData = {
				title: data.titulo,
				text: data.descripcion,
				url: data.link ? data.link : window.location.origin
			};
			//console.log(clearData);
			if (navigator.share) {
				navigator
					.share(clearData)
					.then(() => console.log("Successful share"))
					.catch(error => console.log("Error sharing", error));
			} else {
				//no soportado
				//console.warn("Share Manual");
				this.dialog_share = true;
				this.toShare = clearData;
			}
		},
		closeModal() {
			this.dialog_share = false;
		}
	}
};
</script>
